import router from '@/router/index';
import store from '@/store/index';
import { Preferences } from '@capacitor/preferences';
import { getAppGlobalContext } from '@/utils/app-global-context';
import { isNetworkConnected } from '@/utils/network-status';

/** Сброс клиентской сессии; гостя при сети ведём на витрину, без сети — на экран входа. */
export async function clearClientSessionAndRedirectGuest(sessionExpired = true): Promise<void> {
  localStorage.removeItem('jhi-authenticationToken');
  sessionStorage.removeItem('jhi-authenticationToken');
  localStorage.removeItem('cached-authorities');
  void Preferences.remove({ key: 'jwt' }).then(() => Preferences.remove({ key: 'cached-authorities' }));

  store.commit('logout');

  const g = getAppGlobalContext();
  const current = router.currentRoute.value;
  const name = current.name as string | undefined;
  if (name === 'Login' || name === 'Showcase') {
    return;
  }

  const online = await isNetworkConnected();
  if (online && g) {
    g.offlineMode = false;
  }

  const query = sessionExpired ? { sessionExpired: '1' } : undefined;
  if (online) {
    await router.replace({ path: '/showcase', query });
  } else {
    await router.replace({ path: '/login', query });
  }
}
